const CACHE_PREFIX = 'manakirana_product_search_';
const CACHE_TIME = 5 * 60 * 1000; // 5 minutes

const getCacheKey = (keyword) =>
  `${CACHE_PREFIX}${String(keyword || '').trim().toLowerCase()}`;

export const getCachedSearch = (keyword) => {
  try {
    const savedValue = localStorage.getItem(getCacheKey(keyword));

    if (!savedValue) {
      return null;
    }

    const parsedValue = JSON.parse(savedValue);

    if (!parsedValue?.data) {
      return null;
    }

    return {
      data: parsedValue.data,
      expired: Date.now() - parsedValue.savedAt > CACHE_TIME,
    };
  } catch (error) {
    console.error('Search cache read failed:', error);
    return null;
  }
};

export const saveSearchCache = (keyword, data) => {
  try {
    localStorage.setItem(
      getCacheKey(keyword),
      JSON.stringify({
        savedAt: Date.now(),
        data,
      })
    );
  } catch (error) {
    console.error('Search cache save failed:', error);
  }
};

export const clearProductSearchCache = () => {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(CACHE_PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    console.error('Search cache clear failed:', error);
  }
};